import { TSpeaker } from 'types'
import { v4 as uuidv4 } from 'uuid'

import JeffPhoto from 'assets/images/speakers/jeff.jpeg'
import InnaPhoto from 'assets/images/speakers/inna.jpeg'
import VahePhoto from 'assets/images/team/Vahe.png'
import AramPhoto from 'assets/images/speakers/aram.jpg'
import GagikPhoto from 'assets/images/speakers/gagik.jpg'
import TejasPhoto from 'assets/images/speakers/tejas.jpeg'
import MananPhoto from 'assets/images/speakers/manan.jpeg'
import ArsenPhoto from 'assets/images/speakers/arsen.jpg'
import EdmondPhoto from 'assets/images/speakers/edmond.jpeg'
import GiorgiPhoto from 'assets/images/speakers/giorgi.jpg'
import MarcinPhoto from 'assets/images/speakers/marcin.jpg'
import MariuszPhoto from 'assets/images/speakers/mariusz.jpeg'
import AntonBebenkoPhoto from 'assets/images/speakers/antonBebenko.jpeg'

const speakersData2025: TSpeaker[] = [
  {
    id: uuidv4(),
    name: 'Vahe Momjyan',
    position: 'Chief Software Officer at TACTUN',
    image: VahePhoto,
    link: 'https://www.linkedin.com/in/vahemomjyan/',
    style: {
      objectPosition: 'top',
    },
  },
  {
    id: uuidv4(),
    name: 'Jeffrey Barr',
    isKeyNoteSpeaker: true,
    position: 'Vice President and Chief Evangelist at AWS',
    image: JeffPhoto,
    link: 'https://www.linkedin.com/in/jeffbarr/',
    videoUrl: 'https://www.youtube.com/embed/uW03r9MCGNc?si=iY9xh3p1XetdJDI-',
    style: {
      objectPosition: 'top',
    },
  },
  {
    id: uuidv4(),
    name: 'Anton Babenko',
    isKeyNoteSpeaker: true,
    position: 'AWS Community Hero / Terraform influencer, CEO and CTO at Betajob AS',
    image: AntonBebenkoPhoto,
    link: 'https://www.linkedin.com/in/antonbabenko/',
    videoUrl: 'https://www.youtube.com/embed/Jc4QXq5QGUc?si=MLglYZX14TKA5pzI',
    style: {
      objectPosition: 'top',
    },
  },
  {
    id: uuidv4(),
    name: 'Tejas Gupta',
    position: 'Platform Engineer at PhysicsWallah',
    image: TejasPhoto,
    link: 'https://www.linkedin.com/in/tejasguptaa/',
    style: {
      objectPosition: 'top',
    },
  },
  {
    id: uuidv4(),
    name: 'Manan Verma',
    position: 'Engineering Leader',
    image: MananPhoto,
    link: 'https://www.linkedin.com/in/mananverma/',
    style: {
      objectPosition: 'top',
    },
  },
  {
    id: uuidv4(),
    name: 'Aram Karapetyan',
    position: 'Lead Cloud Architect at Das Meta',
    image: AramPhoto,
    link: 'https://www.linkedin.com/in/aramkarapetyan/',
    style: {
      objectPosition: 'top',
    },
  },
  {
    id: uuidv4(),
    name: 'Edmond Bokhyan',
    position: 'Senior Software Engineer at Grid Dynamics',
    image: EdmondPhoto,
    link: 'https://www.linkedin.com/in/ebokhyan/',
    style: {
      objectPosition: 'top',
    },
  },
  {
    id: uuidv4(),
    name: 'Inna Ozhogina',
    position: 'Country Manager CEA at AWS',
    image: InnaPhoto,
    link: 'https://www.linkedin.com/in/innaozhogina/',
    style: {
      objectPosition: 'top',
    },
  },
  {
    id: uuidv4(),
    name: 'Arsen Muradyan',
    position: 'Senior CloudOps Engineer at QLess',
    image: ArsenPhoto,
    link: 'https://www.linkedin.com/in/arsen-muradyan/',
    style: {
      objectPosition: 'top',
    },
  },
  {
    id: uuidv4(),
    name: 'Giorgi Keratishvili',
    position: 'Lead Systems Engineer at EPAM Systems',
    image: GiorgiPhoto,
    link: 'https://www.linkedin.com/in/keratishvili/',
    style: {
      objectPosition: 'top',
    },
  },

  {
    id: uuidv4(),
    name: 'Mariusz Mikcinski',
    position: 'Senior Cloud Infrastructure Architect at AWS',
    image: MariuszPhoto,
    link: 'https://www.linkedin.com/in/mikcin/',
    style: {
      objectPosition: 'top',
    },
  },
  {
    id: uuidv4(),
    name: 'Marcin Czelej',
    position: 'ML Engineer at AWS',
    image: MarcinPhoto,
    link: 'https://www.linkedin.com/in/marcin-czelej-84501192/',
    style: {
      objectPosition: 'center',
    },
  },
  {
    id: uuidv4(),
    name: 'Gagik Khalafyan',
    position: 'Data Scientist at EPAM Systems',
    image: GagikPhoto,
    link: 'https://www.linkedin.com/in/gagik-khalafyan-b033a0211?miniProfileUrn=urn%3Ali%3Afs_miniProfile%3AACoAADWg5DMB_dbJdlQXGCxeIEk34bsqF9hjWIM&lipi=urn%3Ali%3Apage%3Ad_flagship3_search_srp_all%3BbLS%2FLFmiTgOkdWyRPValEA%3D%3D',
    style: {
      objectPosition: 'center 26%',
    },
  },
]

export default speakersData2025
